export default __webpack_public_path__ + "static/media/481.86c9af63.png";